import { useRef, useState } from 'react';
import _ from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Close as CloseIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import AgentDownloadWizard from './AgentDownloadWizard';
import { AGENT_HOST_HTTP_CLIENT_CURL, AGENT_OS_WINDOWS, AGENT_VIRTUAL_290_MODEL } from './AgentConstants';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDialogTitle-root': {
            paddingTop: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingBottom: 0,
        },
    },
    closeButton: {
        float: 'right',
        marginTop: theme.spacing(-1),
        marginRight: theme.spacing(-1),
    },
    warningButton: {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.main,

        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
}));

/**
 * @typedef {{
 *      model: 'NP-2000V' | 'NP-3000V',
 *      os: 'windows' | 'linux' | 'dockerMac',
 *      httpClient: 'curl' | 'wget'
 *  }} WizardSelections
 *
 * @typedef {import('react').MutableRefObject<WizardSelections>} WizardSelectionsRef
 * @typedef {{ wizardSelections: WizardSelectionsRef }} WizardProps
 */

const wizardDefaults = {
    model: AGENT_VIRTUAL_290_MODEL,
    os: AGENT_OS_WINDOWS,
    httpClient: AGENT_HOST_HTTP_CLIENT_CURL,
};

export function AgentDownloadDialog(props) {
    const classes = useStyles();
    const { open, setOpen } = props;
    const [activeStep, setActiveStep] = useState(0);
    const wizardSelections = useRef(_.cloneDeep(wizardDefaults));
    const disableEnforceFocus = true;

    const handleOnClose = () => {
        setActiveStep(0);
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
            className={classes.root}
            maxWidth="md"
            disableEnforceFocus={disableEnforceFocus}
        >
            <DialogTitle id="confirm-dialog">
                <IconButton aria-label="cancel" className={classes.closeButton} onClick={handleOnClose} tabIndex={-1}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <AgentDownloadWizard
                    closeDialog={handleOnClose}
                    wizardSelections={wizardSelections}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    wizardDefaults={wizardDefaults}
                />
            </DialogContent>
        </Dialog>
    );
}
